import React, { useEffect } from 'react';
import '@styles/react/apps/app-users.scss';
import { useForm } from 'react-hook-form';
import Table from './Table';

function CustomTable({
  store,
  data,
  loading,
  refetch,
  variables,
  columns,
  headerOptions,
  headerOptionsModal,
  handleDownload,
  loadingDownload,
  filterOptions,
  sidebar,
  pagination = true
}) {
  const {
    control,
    watch,
    formState: { errors },
    setValue
  } = useForm({
    defaultValues: variables.search
  });
  const page = watch('page');

  useEffect(() => {
    const subscription = watch((search) => {
      refetch({
        search
      });
    });
    if (page > data.totalPages) {
      setValue('page', data.totalPages);
    }
    return () => subscription.unsubscribe();
  }, [watch, loading, data]);

  return (
    <div className="app-user-list">
      <Table
        store={store}
        data={data}
        loading={loading}
        control={control}
        errors={errors}
        setValue={setValue}
        columns={columns}
        pagination={pagination}
        filterOptions={filterOptions}
        headerOptions={headerOptions}
        headerOptionsModal={headerOptionsModal}
        handleDownload={handleDownload}
        loadingDownload={loadingDownload}
      />
      {sidebar && sidebar}
    </div>
  );
}

export default CustomTable;
